import { render, staticRenderFns } from "./SqueezePage.vue?vue&type=template&id=2c334640&scoped=true&"
import script from "./SqueezePage.vue?vue&type=script&lang=js&"
export * from "./SqueezePage.vue?vue&type=script&lang=js&"
import style0 from "./SqueezePage.vue?vue&type=style&index=0&id=2c334640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c334640",
  null
  
)

export default component.exports